function humanize(str: string) {
  const loveredString = str.toLowerCase()

  // eslint-disable-next-line
  var i,
    frags = loveredString.split('_')
  for (i = 0; i < frags.length; i++) {
    if (frags[i] != 'of' && frags[i] != 'on' && frags[i] != 'to') {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
    }
  }
  return frags.join(' ')
}

export default {
  humanize,
}
